import { default as night } from '@assets/hdri/dikhololo_night_1k.hdr?url';
import { default as warehouse } from '@assets/hdri/empty_warehouse_01_1k.hdr?url';
import { default as forest } from '@assets/hdri/forest_slope_1k.hdr?url';
import { default as dawn } from '@assets/hdri/kiara_1_dawn_1k.hdr?url';
import { default as apartment } from '@assets/hdri/lebombo_1k.hdr?url';
import { default as city } from '@assets/hdri/potsdamer_platz_1k.hdr?url';
import { default as park } from '@assets/hdri/rooitou_park_1k.hdr?url';
import { default as lobby } from '@assets/hdri/st_fagans_interior_1k.hdr?url';
import { default as studio } from '@assets/hdri/studio_small_03_1k.hdr?url';
import { default as sunset } from '@assets/hdri/venice_sunset_1k.hdr?url';

const Presets = { apartment, city, dawn, forest, lobby, night, park, studio, sunset, warehouse };

export type PresetsType = keyof typeof Presets;

export default Presets;
